import { required } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { DocumentMergeFieldsFormValues } from "./DocumentWriterMergeFormDialog.types.ts";

export class DocumentWriterMergeFieldsLetterFormValidator extends Validator<DocumentMergeFieldsFormValues> {
  constructor() {
    super();

    this.forField("patientId", [required()]);
    this.forField("toContactId", [required()]);
  }
}
